<template>
    <v-card class="fill-height scrollable">
        <v-layout row fill-height class="scrollable">
            <v-flex xs4 class="fill-height scrollable" >
                <v-layout column fill-height class="scrollable">
                    <!--                <v-flex shrink class="subheading primary&#45;&#45;text pa-2">-->
                    <!--                    Workflow Groups-->
                    <!--                </v-flex>-->
                    <v-flex shrink class="body-1 title-color white--text pa-2">
                        Workflow Groups
                    </v-flex>
                    <v-flex shrink class="caption greyType--text font-weight-bold pl-2 pt-1">
                        Add Workflow Group:
                    </v-flex>
                    <v-flex shrink class="px-4 py-1 pb-2">
                        <v-layout row>
                            <v-flex xs6 class="">
                                <app-create-workflow-group
                                        :userInfo="userInfo"
                                        :selectedWorkflow="selectedWorkflow"
                                        :userGroups="userGroups"
                                        @workflowGroupAdded="addWorkflowGroup($event)"
                                >
                                    <v-btn
                                            small
                                            color="secondary"
                                            flat
                                            block
                                            outline
                                            class="pa-0 ma-0"
                                            slot="activator"
                                    >
                                        New
                                    </v-btn>
                                </app-create-workflow-group>

                            </v-flex>
                            <v-flex xs6 class="pl-2">
                                <app-add-existing-workflow-group
                                        :userInfo="userInfo"
                                        :selectedWorkflow="selectedWorkflow"
                                        :workflow-groups="availableFullWorkflowGroups"
                                        @workflowGroupAdded="addExistingWorkflowGroup($event)"
                                >
                                    <v-btn
                                            small
                                            color="secondary"
                                            flat
                                            block
                                            outline
                                            class="pa-0 ma-0"
                                            slot="activator"
                                    >
                                        Existing
                                    </v-btn>
                                </app-add-existing-workflow-group>
                            </v-flex>
                        </v-layout>

                    </v-flex>
                    <v-flex shrink>
                        <v-divider ></v-divider>
                    </v-flex>
                    <v-flex shrink class="px-2 pb-1 pt-2" v-if="filteredSelectedWorkflowGroups.length >= 2 || !blankString(workflowGroupFilter)">
                        <v-text-field
                                label="Filter Workflow Groups"
                                flat
                                single-line
                                v-model="workflowGroupFilter"
                                color="primary"
                                hide-details
                                style="width: 100%;"
                                class="ma-0 pa-0"
                                prepend-inner-icon="search"
                                lazy
                                clearable
                        />
                    </v-flex>
                    <v-flex xs12 class="scrollable fill-height fill-height" style="overflow-x: hidden">
                        <div v-for="item in filteredSelectedWorkflowGroups" :key="item.id" >
                            <div
                                    :class="selectedWorkflowGroup != null && selectedWorkflowGroup.id == item.id ? 'selected-item' : 'hover-item'"
                                    :style="disableWorkflowGroupClicks ? 'cursor: progress' : 'cursor: pointer'"
                            >
                                <v-layout row align-center style="overflow-x: hidden" class="hide-parent">
                                    <v-flex
                                            shrink
                                            v-if="selectedWorkflowGroup != null && selectedWorkflowGroup.id == item.id && (renamingGroup || removingGroup)"
                                            class="pl-2 py-1"
                                    >
                                        <v-progress-circular
                                                :size="20"
                                                :width="2"
                                                color="primary"
                                                indeterminate
                                        />
                                    </v-flex>
                                    <v-flex xs12 style="overflow-x: hidden" class="pa-2" @click="!disableWorkflowGroupClicks ? selectedWorkflowGroup = item : ''">
                                        <div class="body-1">
                                            {{item.description}}
                                        </div>
                                        <div class="caption text-truncate" :class="Array.isArray(item.members) ? 'greyType--text' : 'red--text'" style="overflow-x: hidden">
                                            {{Array.isArray(item.members) ? item.members.map(obj => {return obj.description}).join(', ') : 'NO USER GROUPS ASSIGNED'}}
                                        </div>
                                    </v-flex>
                                    <v-flex shrink class="pr-1 hide-child">
                                        <v-tooltip right>
                                            <v-btn
                                                    small
                                                    flat
                                                    icon
                                                    color="primary"
                                                    style="width: 18px; height: 18px"
                                                    class="pa-0 ma-0"
                                                    @click="!disableWorkflowGroupClicks ? renameWorkflowGroupRunStart(item) : ''"
                                                    slot="activator"
                                            >
                                                <v-icon small>edit</v-icon>
                                            </v-btn>
                                            <span>Rename Workflow Group</span>
                                        </v-tooltip>
                                    </v-flex>
                                    <v-flex shrink class="pr-2 hide-child">
                                        <div>
                                            <v-tooltip right>
                                                <v-btn
                                                        small
                                                        flat
                                                        icon
                                                        color="red"
                                                        style="width: 18px; height: 18px"
                                                        class="pa-0 ma-0"
                                                        slot="activator"
                                                        @click="!disableWorkflowGroupClicks ? removeWorkflowGroup(item) : ''"
                                                >
                                                    <v-icon small>remove</v-icon>
                                                </v-btn>
                                                <span>Remove Workflow Group</span>
                                            </v-tooltip>
                                        </div>
<!--                                        <div>-->
<!--                                            <v-tooltip right>-->
<!--                                                <v-btn-->
<!--                                                        small-->
<!--                                                        flat-->
<!--                                                        icon-->
<!--                                                        color="red"-->
<!--                                                        style="width: 18px; height: 18px"-->
<!--                                                        class="pa-0 ma-0"-->
<!--                                                        @click="!disableWorkflowGroupClicks ? deleteConfirmRunStart(item) : ''"-->
<!--                                                        slot="activator"-->
<!--                                                >-->
<!--                                                    <v-icon small>delete</v-icon>-->
<!--                                                </v-btn>-->
<!--                                                <span>Delete Workflow Group</span>-->
<!--                                            </v-tooltip>-->
<!--                                        </div>-->
                                    </v-flex>
                                </v-layout>
                                <v-divider></v-divider>
                            </div>
                        </div>
                    </v-flex>
                </v-layout>
            </v-flex>
                    <v-flex shrink><v-divider class="title-color darken-1" vertical></v-divider></v-flex>
            <v-flex xs4 class="fill-height scrollable" v-if="selectedWorkflowGroup != null">
                <v-layout column fill-height class="scrollable">
                    <v-flex shrink class="body-1 title-color white--text pa-2">
                        User Groups
                    </v-flex>
                    <v-flex shrink class="caption greyType--text font-weight-bold pl-2 pt-1">
                        Add User Groups:
                    </v-flex>
                    <v-flex shrink class="px-4 py-1 pb-2">
                        <v-layout row>

                            <v-flex xs12 v-if="userInfo.userManager == '1'">
                                <app-create-user-group
                                        :userInfo="userInfo"
                                        :selected-workflow-group="selectedWorkflowGroup"
                                        :users="users"
                                        @userGroupAdded="addNewUserGroup($event)"
                                >

                                    <v-btn
                                            small
                                            color="secondary"
                                            flat
                                            block
                                            outline
                                            class="pa-0 ma-0"
                                            slot="activator"
                                    >
                                        New
                                    </v-btn>
                                </app-create-user-group>
                            </v-flex>
                            <v-flex xs12 class="pl-2">
                                <app-add-existing-user-group
                                        :userInfo="userInfo"
                                        :selected-workflow-group="selectedWorkflowGroup"
                                        :userGroups="availableUserGroups"
                                        @userGroupAdded="addExistingUserGroup($event)"
                                >

                                    <v-btn
                                            small
                                            color="secondary"
                                            flat
                                            block
                                            outline
                                            class="pa-0 ma-0"
                                            slot="activator"
                                    >
                                        Existing
                                    </v-btn>
                                </app-add-existing-user-group>

                            </v-flex>
                        </v-layout>


                    </v-flex>
                    <v-flex shrink>
                        <v-divider></v-divider>
                    </v-flex>
                    <v-flex shrink class="px-2 pb-1 pt-2" v-if="Array.isArray(selectedWorkflowGroup.members) && (selectedWorkflowGroup.members.length >= 2 || !blankString(userGroupsFilter))">
                        <v-text-field
                                label="Filter User Groups"
                                flat
                                single-line
                                v-model="userGroupsFilter"
                                color="primary"
                                hide-details
                                style="width: 100%;"
                                class="ma-0 pa-0"
                                prepend-inner-icon="search"
                                lazy
                                clearable
                        />
                    </v-flex>
                    <v-flex xs12 class="scrollable fill-height fill-height" style="overflow-x: hidden">
                        <div v-for="item in filteredSelectedUserGroups" :key="item.id" >
                            <div
                                    :class="selectedUserGroup != null && selectedUserGroup.id == item.id ? 'selected-item' : 'hover-item'"
                                    :style="disableWorkflowGroupClicks || disableUserGroupClicks ? 'cursor: progress' : 'cursor: pointer'"
                            >
                                <v-layout row align-center style="overflow-x: hidden" class="hide-parent">
                                    <v-flex
                                            shrink
                                            v-if="selectedUserGroup != null && selectedUserGroup.id == item.id && (renamingUserGroup || removingUserGroup)"
                                            class="pl-2 py-1"
                                    >
                                        <v-progress-circular
                                                :size="20"
                                                :width="2"
                                                color="primary"
                                                indeterminate
                                        />
                                    </v-flex>
                                    <v-flex xs12 style="overflow-x: hidden" class="pa-2" @click="!disableWorkflowGroupClicks && !disableUserGroupClicks ? selectedUserGroup = item : ''">
                                        <div class="body-1">
                                            {{item.description}}
                                        </div>
                                        <div class="caption text-truncate" :class="Array.isArray(item.members) && item.members.length > 0 ? 'greyType--text' : 'red--text'" style="overflow-x: hidden">
                                            {{Array.isArray(item.members) && item.members.length > 0 ? item.members.map(obj => {return typeof obj != 'undefined' && obj != null ? obj.description : 'ERROR'}).join(', ') : 'NO USER ASSIGNED'}}
                                        </div>
                                    </v-flex>
                                    <v-flex shrink class="pr-2 hide-child">
                                        <div>
                                            <v-tooltip right>
                                                <v-btn
                                                        small
                                                        flat
                                                        icon
                                                        color="red"
                                                        style="width: 18px; height: 18px"
                                                        class="pa-0 ma-0"
                                                        slot="activator"
                                                        @click="!disableWorkflowGroupClicks && !disableUserGroupClicks ? removeUserGroup(item) : ''"
                                                >
                                                    <v-icon small>remove</v-icon>
                                                </v-btn>
                                                <span>Remove User Group</span>
                                            </v-tooltip>
                                        </div>
                                        <div>
                                            <v-tooltip right>
                                                <v-btn
                                                        small
                                                        flat
                                                        icon
                                                        color="primary"
                                                        style="width: 18px; height: 18px"
                                                        class="pa-0 ma-0"
                                                        @click="!disableWorkflowGroupClicks && !disableUserGroupClicks ? renameUserGroupRunStart(item) : ''"
                                                        slot="activator"
                                                >
                                                    <v-icon small>edit</v-icon>
                                                </v-btn>
                                                <span>Rename User Group</span>
                                            </v-tooltip>
                                        </div>
                                    </v-flex>
                                </v-layout>
                                <v-divider></v-divider>
                            </div>
                        </div>
                    </v-flex>
                </v-layout>
            </v-flex>
          <v-flex shrink><v-divider class="title-color darken-1" vertical></v-divider></v-flex>
            <v-flex xs4 class="fill-height scrollable" v-if="selectedUserGroup != null">
                <v-layout column fill-height class="scrollable">
                    <v-flex shrink class="body-1 title-color white--text pa-2 ">
                        Users
                    </v-flex>
                    <v-flex shrink class="caption greyType--text font-weight-bold pl-2 pt-1">
                        Add User to Group:
                    </v-flex>
                    <v-flex shrink class="px-4 py-1 pb-2">
                        <app-add-user
                                :userInfo="userInfo"
                                :selected-user-group="selectedUserGroup"
                                :users="availableUsers"
                                @userAdded="addExistingUser($event)"
                                :disabled="userInfo.userManager == '0'"
                        >
                            <v-btn
                                    small
                                    color="secondary"
                                    flat
                                    block
                                    outline
                                    class="pa-0 ma-0"
                                    slot="activator"
                                    :disabled="userInfo.userManager == '0'"
                            >
                                Add User
                            </v-btn>
                        </app-add-user>
                    </v-flex>
                    <v-flex shrink>
                        <v-divider></v-divider>
                    </v-flex>
                    <v-flex shrink class="px-2 pb-1 pt-2" v-if="Array.isArray(selectedUserGroup.members) && (selectedUserGroup.members.length >= 2 || !blankString(usersFilter))">
                        <v-text-field
                                label="Filter Users"
                                flat
                                single-line
                                v-model="usersFilter"
                                color="primary"
                                hide-details
                                style="width: 100%;"
                                class="ma-0 pa-0"
                                prepend-inner-icon="search"
                                lazy
                                clearable
                        />
                    </v-flex>
                    <v-flex xs12 class="scrollable fill-height fill-height" style="overflow-x: hidden">
                        <div v-for="(item, n) in filteredSelectedUsers" :key="n" >
                            <div
                                    v-if="typeof item != 'undefined'"
                                    :class="selectedUser != null && selectedUser.id == item.id ? 'selected-item' : 'hover-item'"
                                    :style="disableWorkflowGroupClicks || disableUserGroupClicks || disableUserClicks ? 'cursor: progress' : 'cursor: pointer'"
                            >
                                <v-layout row align-center style="overflow-x: hidden" class="hide-parent">
                                    <v-flex
                                            shrink
                                            v-if="selectedUser != null && selectedUser.id == item.id && removingUser"
                                            class="pl-2 py-1"
                                    >
                                        <v-progress-circular
                                                :size="20"
                                                :width="2"
                                                color="primary"
                                                indeterminate
                                        />
                                    </v-flex>
                                    <v-flex xs12 style="overflow-x: hidden" class="pa-2" @click="!disableWorkflowGroupClicks && !disableUserGroupClicks && !disableUserClicks ? selectedUser = item : ''">
                                        <div class="body-1" :class="selectedUser != null && selectedUser.id == item.id ? '' : (intToBool(item.disabled) ? 'greyType--text' : '')">
                                            {{`${item.description}${intToBool(item.disabled) ? ' (Disabled)' : ''}`}}
                                        </div>
                                        <div class="caption text-truncate greyType--text"  style="overflow-x: hidden">
                                            {{item.username}}
                                        </div>
                                    </v-flex>
                                    <v-flex shrink class="pr-2 hide-child" v-if="userInfo.userManager == '1'">
                                        <v-tooltip left>
                                            <v-btn
                                                    small
                                                    flat
                                                    icon
                                                    color="red"
                                                    style="width: 18px; height: 18px"
                                                    class="pa-0 ma-0"
                                                    slot="activator"
                                                    @click="!disableWorkflowGroupClicks && !disableUserGroupClicks && !disableUserClicks? removeUser(item) : ''"
                                            >
                                                <v-icon small>remove</v-icon>
                                            </v-btn>
                                            <span>Remove User from Group</span>
                                        </v-tooltip>
                                    </v-flex>
                                </v-layout>
                                <v-divider></v-divider>
                            </div>
                        </div>
                    </v-flex>
                </v-layout>
            </v-flex>
            <!--Rename Workflow Group-->
            <app-input-dlg
                    v-if="showRenameWorkflowGroup"
                    :show-dialog="showRenameWorkflowGroup"
                    title="Rename Workflow Group"
                    body="New Description:"
                    :cancel-button="true"
                    :show-input-box="true"
                    :default-input="selectedWorkflowGroup.description"
                    :buttons="['Rename']"
                    :call-backs="[ renameWorkflow ]"
                    @dismiss="showRenameWorkflowGroup = false"
            />
            <!--Delete Workflow Group-->
            <app-input-dlg
                    v-if="showConfirmDelete"
                    :show-dialog="showConfirmDelete"
                    title="Delete Workflow Group"
                    :body="`Are you sure that you would like to delete '${selectedWorkflowGroup.description}' this action can not be undone. It will delete the Workflow Group from other workflows as well.`"
                    :cancel-button="true"
                    :show-input-box="false"
                    :buttons="['Delete', 'Cancel']"
                    :call-backs="[ deleteWorkflowGroup, cancelDeleteWorkflowGroup ]"
                    @dismiss="showConfirmDelete = false"
            />
            <!--Rename User Group-->
            <app-input-dlg
                    v-if="showRenameUserGroup"
                    :show-dialog="showRenameUserGroup"
                    title="Rename User Group"
                    body="New Description:"
                    :cancel-button="true"
                    :show-input-box="true"
                    :default-input="selectedUserGroup.description"
                    :buttons="['Rename']"
                    :call-backs="[ renameUserGroup ]"
                    @dismiss="showRenameUserGroup = false"
            />
        </v-layout>
    </v-card>

</template>

<script>
    import {codeBaseMixin} from "../../../../../codeBaseMixin";
    import InputDlg from "../../../../../components/General/InputDlg";
    import CreateWorkflowGroup from "./CreateWorkflowGroup";
    import AddExistingWorkflowGroup from "./AddExistingWorkflowGroup";
    import AddExistingUserGroup from "./AddExistingUserGroup";
    import AddUser from "./AddUser";
    import CreateUserGroup from "./CreateUserGroup";

    export default {
        components: {
            appInputDlg: InputDlg,
            appCreateWorkflowGroup: CreateWorkflowGroup,
            appAddExistingWorkflowGroup: AddExistingWorkflowGroup,
            appAddExistingUserGroup: AddExistingUserGroup,
            appAddUser: AddUser,
            appCreateUserGroup: CreateUserGroup,
        },
        mixins: [codeBaseMixin],
        props: {
            userInfo: Object,
            selectedWorkflow: Object,
            workflowViewOption: Number
        },

        data() {
            return {
                loading: false,
                selectedGroups: [],
                allGroups: [],
                userGroups: [],
                users: [],
                workflowGroupFilter: '',
                selectedWorkflowGroup: null,
                renamingGroup: false,
                showRenameWorkflowGroup: false,
                removingGroup: false,
                showConfirmDelete: false,
                userGroupsFilter: null,
                selectedUserGroup: null,
                renamingUserGroup: false,
                removingUserGroup: false,
                showRenameUserGroup: false,
                usersFilter: null,
                selectedUser: null,
                removingUser: false
            }
        },

        watch: {
            selectedWorkflow: {
                immediate: true,
                handler() {
                    this.securityStartup();
                }
            },
            selectedWorkflowGroup() {
                this.selectedUserGroup = null;
                this.userGroupsFilter = null;
            },
            selectedUserGroup() {
                this.usersFilter = null;
                this.selectedUser = null;
            }
        },

        methods: {
            addExistingUser(user) {

                this.userGroups.forEach(UGroup => {
                    if (UGroup.id == this.selectedUserGroup.id) {
                        UGroup.members.push(user.id);

                    }
                });

                let selectedUserGroupID = this.selectedUserGroup.id;
                this.selectedWorkflowGroup = this.filteredSelectedWorkflowGroups.filter(obj => obj.id == this.selectedWorkflowGroup.id).pop();
                this.$nextTick(() => {
                    this.selectedUserGroup = this.filteredSelectedUserGroups.filter(obj => obj.id == selectedUserGroupID).pop();
                    this.$nextTick(() => {
                        this.selectedUser = user;
                    })
                });


                // this.allGroups.forEach(WFGroup => {
                //     if (WFGroup.id == this.selectedWorkflowGroup.id) {
                //         WFGroup.members.push(group.id)
                //     }
                // });
                //
                // this.selectedWorkflowGroup = this.filteredSelectedWorkflowGroups.filter(obj => obj.id == this.selectedWorkflowGroup.id).pop();
                //
                // this.$nextTick(() => {
                //     this.selectedUserGroup = this.filteredSelectedUserGroups.filter(obj => obj.id == group.id).pop();
                // });
            },
            removeUser(user) {
                this.selectedUser = user;
                this.removingUser = true;
                this.fetch({method: 'DELETE', url:`/workflowManager/security/user/${this.userInfo.entityID}/${this.selectedUserGroup.id}/${this.selectedUser.id}`})
                    .then(() => {
                        this.userGroups.forEach(UGroup => {
                            if (UGroup.id == this.selectedUserGroup.id) {
                                UGroup.members = UGroup.members.filter(obj => obj != this.selectedUser.id);
                            }
                        });
                        let selectedUserGroupID = this.selectedUserGroup.id;
                        this.selectedWorkflowGroup = this.filteredSelectedWorkflowGroups.filter(obj => obj.id == this.selectedWorkflowGroup.id).pop();
                        this.$nextTick(() => {
                            this.selectedUserGroup = this.filteredSelectedUserGroups.filter(obj => obj.id == selectedUserGroupID).pop();
                        });
                        this.selectedUser = null;
                        this.removingUser = false;
                        this.showSnack('Info', 'User Removed', 'Close', 'primary')
                    })
                    .catch((e) => {
                        // eslint-disable-next-line
                        console.log(e);
                        this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
                        this.removingUser = false;
                    })
            },
            addExistingUserGroup(group) {
                this.allGroups.forEach(WFGroup => {
                    if (WFGroup.id == this.selectedWorkflowGroup.id) {
                        if (!Array.isArray(WFGroup.members)) {
                            WFGroup.members = []
                        }
                        WFGroup.members.push(group.id)
                    }
                });

                this.selectedWorkflowGroup = this.filteredSelectedWorkflowGroups.filter(obj => obj.id == this.selectedWorkflowGroup.id).pop();

                this.$nextTick(() => {
                    this.selectedUserGroup = this.filteredSelectedUserGroups.filter(obj => obj.id == group.id).pop();
                });
            },
            addNewUserGroup(group) {
                this.userGroups.push(group);

                this.allGroups.forEach(WFGroup => {
                    if (WFGroup.id == this.selectedWorkflowGroup.id) {
                        if (!Array.isArray(WFGroup.members)) {
                            WFGroup.members = []
                        }
                        WFGroup.members.push(group.id)
                    }
                });

                this.selectedWorkflowGroup = this.filteredSelectedWorkflowGroups.filter(obj => obj.id == this.selectedWorkflowGroup.id).pop();

                this.$nextTick(() => {
                    this.selectedUserGroup = this.filteredSelectedUserGroups.filter(obj => obj.id == group.id).pop();
                });
            },
            renameUserGroupRunStart(group) {
                this.selectedUserGroup = group;
                this.showRenameUserGroup = true
            },
            renameUserGroup(description) {
                if (this.blankString(description)) {
                    this.showSnack('Error', 'A description is required', 'Close', 'red')
                } else {
                    this.showRenameUserGroup = false;
                    this.renamingUserGroup = true;
                    this.fetch({method: 'PATCH', url:`/workflowManager/security/userGroup/${this.userInfo.entityID}/${this.selectedUserGroup.id}`, body: JSON.stringify({description: description})})
                        .then(() => {
                            this.userGroups.forEach(userGroup => {
                                if (userGroup.id == this.selectedUserGroup.id) {
                                    userGroup.description = description
                                }
                            });
                            let selectedUserGroupID = this.selectedUserGroup.id;
                            this.selectedWorkflowGroup = this.filteredSelectedWorkflowGroups.filter(obj => obj.id == this.selectedWorkflowGroup.id).pop();
                            this.userGroups = this.userGroups.filter(() => true);
                            this.$nextTick(() => {
                                this.selectedUserGroup = this.filteredSelectedUserGroups.filter(obj => obj.id == selectedUserGroupID).pop();
                            });
                            this.renamingUserGroup = false;
                            this.showSnack('Info', 'Changes Saved', 'Close', 'primary')
                        })
                        .catch((e) => {
                            // eslint-disable-next-line
                            console.log(e);
                            this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
                            this.renamingUserGroup = false;
                        })
                }
            },
            removeUserGroup(group) {
                this.selectedUserGroup = group;
                this.removingUserGroup = true;
                this.fetch({method: 'DELETE', url:`/workflowManager/security/userGroup/${this.userInfo.entityID}/${this.selectedWorkflowGroup.id}/${this.selectedUserGroup.id}`})
                    .then(() => {
                        this.allGroups.forEach(WFGroup => {
                            if (WFGroup.id == this.selectedWorkflowGroup.id) {
                                WFGroup.members = WFGroup.members.filter(obj => obj != this.selectedUserGroup.id);
                            }
                        })


                        this.selectedWorkflowGroup = this.filteredSelectedWorkflowGroups.filter(obj => obj.id == this.selectedWorkflowGroup.id).pop();

                        this.selectedUserGroup = null;
                        this.removingUserGroup = false;
                        this.showSnack('Info', 'Group Removed', 'Close', 'primary')
                    })
                    .catch((e) => {
                        // eslint-disable-next-line
                        console.log(e);
                        this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
                        this.removingUserGroup = false;
                    })
            },
            addWorkflowGroup(group) {
                this.allGroups.push(group);
                if (!Array.isArray(this.selectedGroups)) {
                    this.selectedGroups = []
                }
                this.selectedGroups.push(group.id);
                this.$nextTick(() => {
                    this.selectedWorkflowGroup = this.filteredSelectedWorkflowGroups.filter(obj => obj.id == group.id).pop();
                });

            },
            addExistingWorkflowGroup(group) {
                if (!Array.isArray(this.selectedGroups)) {
                    this.selectedGroups = []
                }
                this.selectedGroups.push(group.id);
                this.selectedWorkflowGroup = group;
            },
            securityStartup() {
                this.workflowGroupFilter = '';
                this.selectedGroups = [];
                this.allGroups = [];
                this.userGroups = [];
                this.users = [];
                this.selectedWorkflowGroup = null;
                this.loading = true;
                this.fetch({method: 'GET', url:`/workflowManager/security/startup/${this.userInfo.entityID}/${this.selectedWorkflow.id}`})
                    .then((data) => {
                        this.selectedGroups = data.selectedGroups;
                        this.allGroups = data.allGroups;
                        this.userGroups = data.userGroups;
                        this.users = data.users;
                        this.loading = false
                    })
                    .catch((e) => {
                        // eslint-disable-next-line
                        console.log(e);
                        this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
                        this.loading = false
                    })
            },
            renameWorkflowGroupRunStart(workflowGroup) {
                this.selectedWorkflowGroup = workflowGroup;
                this.showRenameWorkflowGroup = true;
            },
            renameWorkflow(description) {
                if (this.blankString(description)) {
                    this.showSnack('Error', 'A description is required', 'Close', 'red')
                } else {
                    this.showRenameWorkflowGroup = false;
                    this.renamingGroup = true;
                    this.fetch({method: 'PATCH', url:`/workflowManager/security/workflowGroup/${this.userInfo.entityID}/${this.selectedWorkflowGroup.id}`, body: JSON.stringify({description: description})})
                        .then(() => {
                            this.allGroups.forEach(workflowGroup => {
                                if (workflowGroup.id == this.selectedWorkflowGroup.id) {
                                    workflowGroup.description = description
                                }
                            });
                            this.renamingGroup = false;
                            this.showSnack('Info', 'Changes Saved', 'Close', 'primary')
                        })
                        .catch((e) => {
                            // eslint-disable-next-line
                            console.log(e);
                            this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
                            this.renamingGroup = false;
                        })
                }
            },
            removeWorkflowGroup(workflowGroup) {
                this.selectedWorkflowGroup = workflowGroup;
                this.removingGroup = true;
                this.fetch({method: 'DELETE', url:`/workflowManager/security/workflowGroup/${this.userInfo.entityID}/${this.selectedWorkflow.id}/${this.selectedWorkflowGroup.id}`})
                    .then(() => {
                        this.selectedGroups.forEach((workflowGroupID, n) => {
                            if (workflowGroupID == this.selectedWorkflowGroup.id) {
                                this.selectedGroups.splice(n, 1);
                            }
                        });
                        this.selectedWorkflowGroup = null;
                        this.removingGroup = false;
                        this.showSnack('Info', 'Group Removed', 'Close', 'primary')
                    })
                    .catch((e) => {
                        // eslint-disable-next-line
                        console.log(e);
                        this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
                        this.removingGroup = false;
                    })
            },
            deleteConfirmRunStart(workflowGroup) {
                this.selectedWorkflowGroup = workflowGroup;
                this.showConfirmDelete = true;
            },
            cancelDeleteWorkflowGroup() {
                this.showConfirmDelete = false;
            },
            deleteWorkflowGroup() {
                this.showConfirmDelete = false;
                this.removingGroup = true;
                this.fetch({method: 'DELETE', url:`/workflowManager/security/workflowGroup/remove/group/${this.userInfo.entityID}/${this.selectedWorkflowGroup.id}`})
                    .then(() => {
                        this.selectedGroups.forEach((workflowGroupID, n) => {
                            if (workflowGroupID == this.selectedWorkflowGroup.id) {
                                this.selectedGroups.splice(n, 1);
                            }
                        });
                        this.allGroups.forEach((workflowGroup, n) => {
                            if (workflowGroup.id == this.selectedWorkflowGroup.id) {
                                this.allGroups.splice(n, 1);
                            }
                        });
                        this.selectedWorkflowGroup = null;
                        this.removingGroup = false;
                        this.showSnack('Info', 'Group Deleted', 'Close', 'primary')
                    })
                    .catch((e) => {
                        // eslint-disable-next-line
                        console.log(e);
                        this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
                        this.removingGroup = false;
                    })
            }
        },

        computed: {
            disableUserClicks() {
                return this.renamingGroup || this.removingGroup || this.renamingUserGroup || this.removingUserGroup || this.removingUser ? true : false;
            },
            disableUserGroupClicks() {
                return this.renamingGroup || this.removingGroup || this.renamingUserGroup || this.removingUserGroup ? true : false;
            },
            disableWorkflowGroupClicks() {
                return this.renamingGroup || this.removingGroup ? true : false;
            },
            flatUsers() {
                try {
                    return this.users.reduce((obj, user) => {
                        obj[user.id] = user;
                        return obj
                    }, {})
                } catch (e) {
                    // eslint-disable-next-line
                    console.log(e)
                    return {}
                }
            },
            flatUserGroups() {
                try {
                    return this.userGroups.reduce((obj, group) => {
                        obj[group.id] = {
                            id: group.id,
                            description: group.description,
                            members: !Array.isArray(group.members)
                                ? null
                                : group.members.map((user) => {
                                    try {
                                        return this.flatUsers[user];
                                    } catch (e) {
                                        return null
                                    }
                                })
                        };
                        return obj
                    }, {})
                } catch (e) {
                    // eslint-disable-next-line
                    console.log(e)
                    return {}
                }
            },
            availableFullWorkflowGroups() {
                try {
                    return this.allGroups.filter(obj => Array.isArray(this.selectedGroups) ? !this.selectedGroups.includes(obj.id) : true).reduce((list, workflowGroup) => {
                        let item = {
                            id: workflowGroup.id,
                            description: workflowGroup.description,
                            members: !Array.isArray(workflowGroup.members)
                                ? null
                                : workflowGroup.members.map((userGroup) => {
                                    try {
                                        return this.flatUserGroups[userGroup];
                                    } catch (e) {
                                        return null
                                    }
                                })
                        };
                        list.push(item);
                        return list;
                    }, [])
                } catch (e) {
                    // eslint-disable-next-line
                    console.log(e);
                    return null
                }
            },
            fullWorkflowGroups() {
                try {
                    return this.allGroups.reduce((list, workflowGroup) => {
                        let item = {
                            id: workflowGroup.id,
                            description: workflowGroup.description,
                            members: !Array.isArray(workflowGroup.members)
                                ? null
                                : workflowGroup.members.map((userGroup) => {
                                    try {
                                        return this.flatUserGroups[userGroup];
                                    } catch (e) {
                                        return null
                                    }
                                })
                        };
                        list.push(item);
                        return list;
                    }, [])
                } catch (e) {
                    // eslint-disable-next-line
                    console.log(e);
                    return null
                }
            },
            filteredSelectedWorkflowGroups() {
                if (Array.isArray(this.selectedGroups)) {
                    return this.workflowGroupFilter == null || this.workflowGroupFilter == ''
                        ? this.fullWorkflowGroups.filter(obj => this.selectedGroups.includes(obj.id))
                            .sort((a,b) => a['description'] < b['description'] ? -1 : 1)
                        : this.fullWorkflowGroups.filter(obj => this.selectedGroups.includes(obj.id))
                            .reduce((list, workflowGroup) => {
                                if (
                                    [workflowGroup.description].concat(
                                        !Array.isArray(workflowGroup.members)
                                            ? null
                                            : workflowGroup.members.map(userGroup => {
                                                return [userGroup.description].concat(
                                                    userGroup.members.map(user => {
                                                        return typeof user != 'undefined' ? user.description : null
                                                    }).join(', ')
                                                ).join(', ')
                                            }).join(', ')
                                    ).join(', ').toLowerCase().includes(this.workflowGroupFilter.toLowerCase())
                                ) {
                                    list.push(workflowGroup)
                                }
                                return list
                            }, [])
                            .sort((a,b) => a['description'] < b['description'] ? -1 : 1);
                } else {
                    return [];
                }

            },
            filteredSelectedUserGroups() {
                if (this.selectedWorkflowGroup != null && Array.isArray(this.selectedWorkflowGroup.members)) {
                    return this.blankString(this.userGroupsFilter)
                        ? this.selectedWorkflowGroup.members.filter(obj => true)
                            .sort((a,b) => a['description'] < b['description'] ? -1 : 1)

                        : this.selectedWorkflowGroup.members
                            .reduce((list, userGroup) => {
                                if (
                                    [userGroup.description].concat(
                                        userGroup.members.map(user => {
                                            return typeof user != 'undefined' ? user.description : null
                                        }).join(', ')
                                    ).join(', ')
                                    .toLowerCase().includes(this.userGroupsFilter.toLowerCase())
                                ) {
                                    list.push(userGroup)
                                }
                                return list
                            }, [])
                            .sort((a,b) => a['description'] < b['description'] ? -1 : 1);
                } else {
                    return [];
                }

            },
            availableUserGroups() {
                try {
                    let tExisting = Array.isArray(this.selectedWorkflowGroup.members) ? this.selectedWorkflowGroup.members.map(obj => {return obj.id}) : [];

                    return this.userGroups.filter(obj => !tExisting.includes(obj.id)).map(obj => {return this.flatUserGroups[obj.id]})
                } catch (e) {
                    // eslint-disable-next-line
                    console.log(e)
                  return []
                }
            },
            filteredSelectedUsers() {
                try {
                    if (this.selectedUserGroup != null) {
                        if (this.blankString(this.usersFilter)) {
                            return this.selectedUserGroup.members.filter(() => true)
                            .sort((a,b) => a['description'] < b['description'] ? -1 : 1);
                        } else {
                            return this.selectedUserGroup.members.filter((obj) => `${obj.username} ${obj.description}`.toLowerCase().includes(this.usersFilter.toLowerCase()))
                                .sort((a,b) => a['description'] < b['description'] ? -1 : 1);
                        }

                    } else {
                        return []
                    }

                } catch (e) {
                    // eslint-disable-next-line
                    console.log(e)
                    return []
                }
            },

            availableUsers() {
                try {
                    let tExisting = Array.isArray(this.selectedUserGroup.members) ? this.selectedUserGroup.members.map(obj => {return obj.id}) : [];

                    return this.users.filter(obj => !tExisting.includes(obj.id)).map(obj => {return this.flatUsers[obj.id]})
                } catch (e) {
                    // eslint-disable-next-line
                    console.log(e)
                    return null
                }
            },
        }

    }
</script>

<style scoped>

</style>
